import * as yup from "yup";

export enum CancelReason {
  MissingFunctionality = "Відсутність необхідного функціоналу в додатку",
  CompexInterface = "Незручний інтерфейс, складно розібратись, як користуватись",
  ChooseOtherService = "Вирішив(ла) скористатись іншим сервісом",
  NoSupport = "Не отримав(ла) достатньо підтримки від Служби підтримки",
  Other = "Інша причина",
}

export type FormValues = {
  reason: string[];
  notes?: string;
};

export const validationSchema = yup.object({
  reason: yup.array().min(1, "Вкажіть причину").required("Вкажіть причину"),
  notes: yup.string().when("reason", ([reason], schema) => {
    return reason.includes(CancelReason.Other)
      ? schema.required("Вкажіть іншу причину")
      : schema;
  }),
});
